export default __webpack_public_path__ + "static/media/bianji.ac0d3cfa.png";